import React, { useEffect, useState } from 'react';
import xhr from '../../utils/fetch';
import { useAppSelector } from '../../hooks/useRedux';
import { TabBar, TabItem } from '@wot/components';
import { LPlan } from '../../typings/plan';
import { Link } from 'react-router-dom';
import { PlanCard } from './PlanCard';
import { useTab } from '../../hooks/useTab';

function MyPlans() {
  const { profile } = useAppSelector((state) => state.profileSlice);
  const [plans, setPlans] = useState<LPlan[]>([]);
  const { activeTab, onTabChange } = useTab('all');
  const userData = profile;

  useEffect(() => {
    xhr({
      url: `/t/${userData?._id}/plans`,
      method: 'GET'
    }).then((res) => {
      if (res.status === 'OK') {
        setPlans(res.data);
      }
    });
  }, []);

  return (
    <div className="w-full min-h-screen  p-8">
      <div className="w-full h-full flex flex-col shadow-sm bg-white rounded-md">
        <h1 className="text-2xl font-semibold p-4">My Plans</h1>

        <div className="w-full border-b border-black">
          <div className="px-4">
            <TabBar
              value={activeTab}
              indicatorColor="bg-secondary"
              onChange={onTabChange}
              textColor="text-neutralGray1"
            >
              <TabItem label="All Plans" value="all" fontSize={15} />
              <TabItem label="Active" value="active" />
              <TabItem label="Pending" value="pending" />
              <TabItem label="Completed" value="completed" />
              <TabItem label="Cancelled" value="cancelled" />
            </TabBar>
          </div>
        </div>
        <div className="p-6 flex flex-col gap-4 items-center">
          {activeTab === 'all' ? (
            plans.length === 0 ? (
              <div className="w-full flex flex-col items-center justify-center gap-7 py-10">
                <h1 className="text-2xl font-semibold text-center">You don't have any Plans yet!</h1>
              </div>
            ) : (
              plans.map((plan) => <PlanCard key={plan._id} plan={plan} userId={userData?._id} />)
            )
          ) : plans.filter((plan) => plan.status === activeTab).length === 0 ? (
            <div className="w-full flex flex-col items-center justify-center gap-7 py-10">
              <h1 className="text-2xl font-semibold text-center">{`No ${activeTab} plans yet!`}</h1>
            </div>
          ) : (
            plans
              .filter((plan) => plan.status === activeTab)
              .map((plan) => <PlanCard key={plan._id} plan={plan} userId={userData?._id} />)
          )}
        </div>
      </div>
    </div>
  );
}

export default MyPlans;
